import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_API, // 推荐使用环境变量
  timeout: 10000,
});


export default apiClient;